import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  concessionLetterINSS,
  convivente,
  death,
  others,
  parents,
  seriousIllness,
  specialChild,
  spouses,
  termos,
  menorTutela,
} from './constants';
import { initialValuesGenerator } from './initialValueGenerator';
import { dynamicRule } from './rules';

const { constants } = parentesco;

// Usado nos forms: saldo cotas,  rcm variavel plano b
export const anexosComObito = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoLaudoMedico: dynamicRule('laudoMedico'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoCartaConcessaoINSS: dynamicRule(),

    anexoTermos: dynamicRule(),
    anexoTermoTutelaJudicial: dynamicRule('menorTutela'),
    anexoOutros: dynamicRule(),
  };
  const docs = {
    commons: [...commons],
    others: [...others],
    [constants.PAI]: [...death, ...concessionLetterINSS, ...parents, ...termos],
    [constants.MAE]: [...death, ...concessionLetterINSS, ...parents, ...termos],
    [constants.CONJUGE]: [
      ...death,
      ...concessionLetterINSS,
      ...spouses,
      ...termos,
    ],
    [constants.EX_CONJUGE]: [
      ...death,
      ...concessionLetterINSS,
      ...spouses,
      ...termos,
    ],
    [constants.FILHO]: [
      ...death,
      ...concessionLetterINSS,
      ...childs,
      ...termos,
    ],
    [constants.MENOR_TUTELA]: [
      ...childs,
      ...menorTutela,
      ...death,
      ...concessionLetterINSS,
      ...termos,
    ],
    [constants.FILHO_ESPECIAL]: [
      ...death,
      ...concessionLetterINSS,
      ...childs,
      ...specialChild,
      ...termos,
    ],
    [constants.CONVIVENTE]: [
      ...death,
      ...concessionLetterINSS,
      ...convivente,
      ...casoUniaoEstavel,
      ...termos,
    ],
    [constants.ENTEADO]: [
      ...death,
      ...concessionLetterINSS,
      ...childs,
      ...certidaoGenitor,
      ...termos,
    ],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};

export const commonsDocs = {
  initialValues: {
    anexoRG: '',
    anexoCPF: '',
  },
  rules: {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
  },
  docs: commons,
};

export const commonDocsBeneficiario = {
  initialValues: {
    anexoRG: '',
    anexoCPF: '',
  },
  rules: {
    anexoRG: dynamicRule('beneficiario'),
    anexoCPF: dynamicRule('beneficiario'),
  },
  docs: commons,
};

export const molestiaGraveDocs = {
  initialValues: {
    anexoLaudoSUS: '',
  },
  rules: {
    anexoLaudoSUS: dynamicRule('molestia'),
  },
  docs: {
    molestiaGrave: seriousIllness,
  },
};
